import { render, staticRenderFns } from "./SidebarCards.vue?vue&type=template&id=7781718f"
import script from "./SidebarCards.vue?vue&type=script&lang=js"
export * from "./SidebarCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports